<script>
import bem from '@/utils/bem';
import { mapActions, mapState } from 'vuex';
import UploadImages from '@/components/ux/upload/Upload-images.vue';

const b = bem('frame-details-tab');

export default {
  name: 'FrameDetailsTab',
  components: { UploadImages },
  props: {
    frameId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      form: {
        name: 'photo_art',
        displayName: '',
        url: '',
        seoTitle: '',
        seoDescription: '',
        sizeTitle: '',
        colorTitle: '',
        displaysTitle: '',
        isDisplaysTitle: false,
        orientationTitle: '',
        minForArrows: 3,
      },
      isDefault: false,
      pmVisible: false,
      visible: false,
      usePlaceholder: false,
      isPackage: false,
      isToggle: false,
      isLicense: false,
      isTaxApplied: false,
      files: [],
      defaultFiles: [],
      customSizeEnabled: false,
      customSizeForm: {
        price_per_sq_inch: null,
        base_price: null,
        min_width: 4,
        max_width: 48,
        min_height: 4,
        max_height: 94,
        min_aspect_ratio: 0.25,
        max_aspect_ratio: 4.0,
        optimal_ppi: 220,
      },
      isSaving: false,
    };
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    ...mapActions({
      getFrameDetailsAction: 'createTemplate/getFrameDetails',
      templateFrameAction: 'createTemplate/templateFrame',
      getCollagePreviewImagesAction: 'createTemplate/getCollagePreviewImages',
      postCollagePreviewImagesAction: 'createTemplate/postCollagePreviewImages',
      deleteCollagePreviewImageAction: 'createTemplate/deleteCollagePreviewImage',
      getCustomSizeSettingsAction: 'createTemplate/getProductCustomSizeSettings',
      saveCustomSizeSettingsAction: 'createTemplate/saveProductCustomSizeSettings',
      deleteCustomSizeSettingsAction: 'createTemplate/deleteProductCustomSizeSettings',
    }),
    loadFrameData() {
      if (this.frameId) {
        this.getFrameDetailsAction(this.frameId);
        this.getCollagePreviewImagesAction(this.frameId);
        this.getCustomSizeSettingsAction(this.frameId);
      }
    },
    populateForm() {
      if (this.frameDetails && this.frameDetails.id) {
        const frame = this.frameDetails;
        this.form.name = frame.name || 'photo_art';
        this.form.displayName = frame.displayName || '';
        this.form.url = frame.url || '';
        this.form.seoTitle = frame.seoTitle || '';
        this.form.seoDescription = frame.seoDescription || '';

        const customInfo = frame.customInfo || {};
        this.form.sizeTitle = customInfo.sizeTitle || '';
        this.form.colorTitle = customInfo.colorTitle || '';
        this.form.displaysTitle = customInfo.displaysTitle || '';
        this.form.isDisplaysTitle = customInfo.isDisplaysTitle || false;
        this.form.orientationTitle = customInfo.orientationTitle || '';
        this.form.minForArrows = customInfo.minForArrows || 3;

        this.isDefault = frame.isDefault || false;
        this.pmVisible = frame.pmVisible || false;
        this.visible = frame.visible || false;
        this.usePlaceholder = frame.usePlaceholder || false;
        this.isPackage = frame.isPackage || false;
        this.isToggle = frame.isToggle || false;
        this.isLicense = frame.isLicense || false;
        this.isTaxApplied = frame.isTaxApplied || false;

        this.defaultFiles = frame.imageUri ? [{
          file: null,
          url: frame.imageUri,
        }] : [];
      }
    },
    async handleSave() {
      this.isSaving = true;
      try {
        const frame = {
          displayName: this.form.displayName,
          isDefault: this.isDefault,
          visible: this.visible,
          pmVisible: this.pmVisible,
          usePlaceholder: this.usePlaceholder,
          isToggle: this.isToggle,
          isPackage: this.isPackage,
          isLicense: this.isLicense,
          isTaxApplied: this.isTaxApplied,
          price: 0,
          url: this.form.url,
          seoTitle: this.form.seoTitle,
          seoDescription: this.form.seoDescription,
          customInfo: JSON.stringify({
            sizeTitle: this.form.sizeTitle || '',
            colorTitle: this.form.colorTitle || '',
            orientationTitle: this.form.orientationTitle || '',
            displaysTitle: this.form.displaysTitle || '',
            isDisplaysTitle: this.form.isDisplaysTitle || false,
            minForArrows: this.form.minForArrows || 3,
          }),
        };

        const file = this.defaultFiles[0]?.file || null;
        await this.templateFrameAction({
          frame,
          file,
          type: 'PUT',
          id: this.frameId,
          name: this.form.name,
        });

        const images = this.files.map(({ file: fl }) => fl || null).filter((item) => item);
        if (images?.length) {
          await this.postCollagePreviewImagesAction({
            images,
            imageNames: images.map((itm) => itm.name),
            productId: this.frameId,
          });
        }

        await this.saveCustomSize();
      } finally {
        this.isSaving = false;
      }
    },
    onRemove(file) {
      const currentImage = this.collagePreviewImage.find(({ imageUrl }) => imageUrl === file.url);
      if (currentImage) {
        this.deleteCollagePreviewImageAction({
          id: currentImage.id,
          productId: this.frameId,
        });
      }
      return false;
    },
    getInitialImages() {
      return this.collagePreviewImage?.length
        ? this.collagePreviewImage.map(({ imageUrl }) => imageUrl)
        : [];
    },
    getDefaultInitialImages() {
      return this.frameDetails?.imageUri ? [this.frameDetails.imageUri] : [];
    },
    async saveCustomSize() {
      // Save if toggle is enabled OR if we have existing settings (to update is_enabled)
      if (this.customSizeEnabled || this.customSizeSettings?.id) {
        await this.saveCustomSizeSettingsAction({
          productId: this.frameId,
          settings: {
            id: this.customSizeSettings?.id,
            price_per_sq_inch: this.customSizeForm.price_per_sq_inch,
            base_price: this.customSizeForm.base_price,
            min_width: this.customSizeForm.min_width || 4,
            max_width: this.customSizeForm.max_width || 48,
            min_height: this.customSizeForm.min_height || 4,
            max_height: this.customSizeForm.max_height || 94,
            min_aspect_ratio: this.customSizeForm.min_aspect_ratio || 0.25,
            max_aspect_ratio: this.customSizeForm.max_aspect_ratio || 4.0,
            optimal_ppi: this.customSizeForm.optimal_ppi || 220,
            is_enabled: this.customSizeEnabled,
          },
          isNew: !this.customSizeSettings?.id,
        });
      }
    },
    deleteCustomSizeSettings() {
      if (this.customSizeSettings?.id) {
        this.deleteCustomSizeSettingsAction({
          id: this.customSizeSettings.id,
          productId: this.frameId,
        });
      }
      this.customSizeEnabled = false;
    },
  },
  computed: {
    ...mapState({
      frameDetails: (state) => state.createTemplate.frameDetails,
      collagePreviewImage: (state) => state.createTemplate.collagePreviewImage,
      isLoadImages: (state) => state.createTemplate.isLoadImages,
      customSizeSettings: (state) => state.createTemplate.customSizeSettings,
    }),
    isCollage() {
      return this.form.name === 'collage';
    },
  },
  mounted() {
    this.loadFrameData();
  },
  watch: {
    frameId: {
      handler(newVal) {
        if (newVal) {
          this.loadFrameData();
        }
      },
    },
    frameDetails: {
      handler() {
        this.populateForm();
      },
      deep: true,
      immediate: true,
    },
    collagePreviewImage: {
      handler(newValue) {
        this.files = newValue.map(({ imageUrl }) => ({ imageUrl, file: null }));
      },
      deep: true,
    },
    customSizeSettings: {
      handler(newValue) {
        // Use isEnabled field (camelCase from API) if available,
        // otherwise fall back to checking if settings exist
        this.customSizeEnabled = newValue?.isEnabled ?? !!newValue;
        if (newValue) {
          this.customSizeForm = {
            price_per_sq_inch: newValue.pricePerSqInch ?? newValue.price_per_sq_inch,
            base_price: newValue.basePrice ?? newValue.base_price,
            min_width: newValue.minWidth ?? newValue.min_width ?? 4,
            max_width: newValue.maxWidth ?? newValue.max_width ?? 48,
            min_height: newValue.minHeight ?? newValue.min_height ?? 4,
            max_height: newValue.maxHeight ?? newValue.max_height ?? 94,
            min_aspect_ratio: newValue.minAspectRatio ?? newValue.min_aspect_ratio ?? 0.25,
            max_aspect_ratio: newValue.maxAspectRatio ?? newValue.max_aspect_ratio ?? 4.0,
            optimal_ppi: newValue.optimalPpi ?? newValue.optimal_ppi ?? 220,
          };
        }
      },
      immediate: true,
    },
  },
};
</script>

<template>
  <div :class="b()">
    <div :class="b('grid')">
      <!-- Basic Info Section -->
      <div :class="b('section')">
        <h3 :class="b('section-title')">Basic Info</h3>
        <div :class="b('section-content')">
          <div :class="b('field')">
            <span :class="b('label')">Type</span>
            <a-select v-model:value="form.name" style="width: 100%">
              <a-select-option value="photo_art">Frame</a-select-option>
              <a-select-option value="collage">Collage</a-select-option>
            </a-select>
          </div>
          <div :class="b('field')">
            <span :class="b('label')">Display name</span>
            <a-input v-model:value="form.displayName" placeholder="Type frame name" />
          </div>
          <div :class="b('field')">
            <span :class="b('label')">Product URL</span>
            <a-input v-model:value="form.url" placeholder="Type product url" />
          </div>
        </div>
      </div>

      <!-- Images Section - spans 2 rows -->
      <div :class="b('section', { tall: true })">
        <h3 :class="b('section-title')">Images</h3>
        <div :class="b('section-content')">
          <div :class="b('image-row')">
            <span :class="b('label')">Default image</span>
            <UploadImages
              v-if="!isLoadImages"
              :is-multiple="false"
              v-model:files="defaultFiles"
              :initial-images="getDefaultInitialImages()"
            />
          </div>
          <div :class="b('image-row')">
            <div :class="b('image-row-header')">
              <span :class="b('label')">Preview images</span>
              <span :class="b('image-hint')">First image - photo art, Second image - enhance</span>
            </div>
            <UploadImages
              v-if="!isLoadImages"
              is-multiple
              v-model:files="files"
              :initial-images="getInitialImages()"
              :onRemove="onRemove"
              :max-number="isCollage ? 10 : 2"
            />
          </div>
        </div>
      </div>

      <!-- SEO Settings Section -->
      <div :class="b('section')">
        <h3 :class="b('section-title')">SEO Settings</h3>
        <div :class="b('section-content')">
          <div :class="b('field')">
            <span :class="b('label')">SEO Title</span>
            <a-input v-model:value="form.seoTitle" placeholder="Type SEO title" />
          </div>
          <div :class="b('field')">
            <span :class="b('label')">SEO Description</span>
            <a-textarea
              v-model:value="form.seoDescription"
              placeholder="Type SEO description"
              :rows="3"
            />
          </div>
        </div>
      </div>

      <!-- Visibility & Options Section -->
      <div :class="b('section')">
        <h3 :class="b('section-title')">Visibility & Options</h3>
        <div :class="b('section-content')">
          <div :class="b('switches')">
            <div :class="b('switch-item')">
              <span :class="b('switch-label')">Default frame</span>
              <a-switch
                v-model:checked="isDefault"
                checked-children="Yes"
                un-checked-children="No"
              />
            </div>
            <div :class="b('switch-item')">
              <span :class="b('switch-label')">Use placeholder</span>
              <a-switch
                v-model:checked="usePlaceholder"
                checked-children="Yes"
                un-checked-children="No"
              />
            </div>
            <div :class="b('switch-item')">
              <span :class="b('switch-label')">Visible on PM</span>
              <a-switch
                v-model:checked="pmVisible"
                checked-children="Yes"
                un-checked-children="No"
              />
            </div>
            <div :class="b('switch-item')">
              <span :class="b('switch-label')">Visible on site</span>
              <a-switch
                v-model:checked="visible"
                checked-children="Yes"
                un-checked-children="No"
              />
            </div>
            <div :class="b('switch-item')">
              <span :class="b('switch-label')">Hide rotate toggle</span>
              <a-switch
                v-model:checked="isToggle"
                checked-children="Yes"
                un-checked-children="No"
              />
            </div>
            <div :class="b('switch-item')">
              <span :class="b('switch-label')">Signage</span>
              <a-switch
                v-model:checked="isPackage"
                checked-children="Yes"
                un-checked-children="No"
              />
            </div>
            <div :class="b('switch-item')">
              <span :class="b('switch-label')">License</span>
              <a-switch
                v-model:checked="isLicense"
                checked-children="Yes"
                un-checked-children="No"
              />
            </div>
            <div :class="b('switch-item')">
              <span :class="b('switch-label')">Tax applied</span>
              <a-switch
                v-model:checked="isTaxApplied"
                checked-children="Yes"
                un-checked-children="No"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- Wizard Settings Section -->
      <div :class="b('section')">
        <h3 :class="b('section-title')">Wizard Settings</h3>
        <div :class="b('section-content')">
          <div :class="b('fields-row')">
            <div :class="b('field')">
              <span :class="b('label')">Size title</span>
              <a-input v-model:value="form.sizeTitle" placeholder="Type size title" />
            </div>
            <div :class="b('field')">
              <span :class="b('label')">Color title</span>
              <a-input v-model:value="form.colorTitle" placeholder="Type color title" />
            </div>
          </div>
          <div :class="b('fields-row')">
            <div :class="b('field')">
              <span :class="b('label')">Type</span>
              <a-select v-model:value="form.isDisplaysTitle" style="width: 100%">
                <a-select-option :value="true">Separate Displays</a-select-option>
                <a-select-option :value="false">Not separate Displays</a-select-option>
              </a-select>
            </div>
            <div :class="b('field')">
              <span :class="b('label')">Displays title</span>
              <a-input v-model:value="form.displaysTitle" placeholder="Type displays title" />
            </div>
          </div>
          <div :class="b('fields-row')">
            <div :class="b('field')">
              <span :class="b('label')">Orientation title</span>
              <a-input v-model:value="form.orientationTitle" placeholder="Type orientation title" />
            </div>
            <div :class="b('field')">
              <span :class="b('label')">Min quantity for arrows</span>
              <a-input-number
                v-model:value="form.minForArrows"
                :min="1"
                style="width: 100%"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- Custom Size Settings Section -->
      <div :class="b('section', { full: true })">
        <h3 :class="b('section-title')">Custom Size Settings</h3>
        <div :class="b('section-content')">
          <div :class="b('switch-item')" style="margin-bottom: 16px;">
            <span :class="b('switch-label')">Enable Custom Size</span>
            <a-switch
              v-model:checked="customSizeEnabled"
              checked-children="Yes"
              un-checked-children="No"
            />
          </div>

          <template v-if="customSizeEnabled">
            <div :class="b('fields-row')">
              <div :class="b('field')">
                <span :class="b('label')">Price per sq inch ($)</span>
                <a-input-number
                  v-model:value="customSizeForm.price_per_sq_inch"
                  :step="0.0001"
                  placeholder="0.15"
                  style="width: 100%"
                />
              </div>
              <div :class="b('field')">
                <span :class="b('label')">Base price ($)</span>
                <a-input-number
                  v-model:value="customSizeForm.base_price"
                  :step="0.01"
                  placeholder="29.99"
                  style="width: 100%"
                />
              </div>
            </div>
            <div :class="b('fields-row')">
              <div :class="b('field')">
                <span :class="b('label')">Min width (inches)</span>
                <a-input-number v-model:value="customSizeForm.min_width" style="width: 100%" />
              </div>
              <div :class="b('field')">
                <span :class="b('label')">Max width (inches)</span>
                <a-input-number v-model:value="customSizeForm.max_width" style="width: 100%" />
              </div>
            </div>
            <div :class="b('fields-row')">
              <div :class="b('field')">
                <span :class="b('label')">Min height (inches)</span>
                <a-input-number v-model:value="customSizeForm.min_height" style="width: 100%" />
              </div>
              <div :class="b('field')">
                <span :class="b('label')">Max height (inches)</span>
                <a-input-number v-model:value="customSizeForm.max_height" style="width: 100%" />
              </div>
            </div>
            <div :class="b('fields-row')">
              <div :class="b('field')">
                <span :class="b('label')">Min aspect ratio</span>
                <a-input-number
                  v-model:value="customSizeForm.min_aspect_ratio"
                  :step="0.01"
                  style="width: 100%"
                />
              </div>
              <div :class="b('field')">
                <span :class="b('label')">Max aspect ratio</span>
                <a-input-number
                  v-model:value="customSizeForm.max_aspect_ratio"
                  :step="0.01"
                  style="width: 100%"
                />
              </div>
            </div>
            <div :class="b('fields-row')">
              <div :class="b('field')">
                <span :class="b('label')">Optimal PPI</span>
                <a-input-number v-model:value="customSizeForm.optimal_ppi" style="width: 100%" />
              </div>
              <div :class="b('field')"></div>
            </div>
            <a-button
              v-if="customSizeSettings?.id"
              type="primary"
              danger
              @click="deleteCustomSizeSettings"
              style="margin-top: 8px;"
            >
              Delete Custom Size Settings
            </a-button>
          </template>
        </div>
      </div>
    </div>

    <!-- Save Button -->
    <div :class="b('actions')">
      <a-button
        type="primary"
        size="large"
        :loading="isSaving"
        @click="handleSave"
      >
        Save Changes
      </a-button>
    </div>
  </div>
</template>

<style src="./style.scss" lang="scss" scoped />
